import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.66634 3.33398H9.99967C12.577 3.33398 14.6663 5.42332 14.6663 8.00065C14.6663 10.578 12.577 12.6673 9.99967 12.6673H9.66634M6.33301 3.33398H5.99967C3.42235 3.33398 1.33301 5.42332 1.33301 8.00065C1.33301 10.578 3.42235 12.6673 5.99967 12.6673H6.33301M5.33301 8.00065H10.6663",
		stroke: "#EFEEF0",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLink;
